<template>
  <div class="tgb-tags">
    <Field labelClass="tgb-label" label="Tags">
      <Inputitems
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
        iconPack="fas"
        icon="tags"
        placeholder="Add a tag"
        inputClass="bg-transparent border-0 pl-6 outline-none"
        itemClass="tgbTag inline-flex items-center gap-1 rounded bg-[#2f2f2f] px-2 py-1"
        expanded
        closeClass="close-tag flex h-5 w-5 items-center justify-center rounded-full border border-white/40 p-0 text-[#23CDF4]"
        rootClass="tgb-tags__input-container"
        v-model="innerModel"
        @add="$emit('add');"
        @remove="$emit('remove');"
        @input="$emit('input')"
        @blur="$emit('blur')"
      >
        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      </Inputitems>
    </Field>
  </div>
</template>

<script>
import Field from '../form/Field.vue';
import Inputitems from '../form/Inputitems.vue';

export default {
  name: 'TagsInput',
  components: {
    Field,
    Inputitems,
  },
  inheritAttrs: false,
  props: ['label', 'value'],
  computed: {
    innerModel: {
      get() {
        return this.value;
      },

      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
</script>
